module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "id": "app-root"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [(_vm.modelServices && _vm.modelToConvergeId) ? _c('div', [_c('uiv-modal', {
    attrs: {
      "backdrop": false,
      "footer": false,
      "title": "Converge " + _vm.modelToConvergeId
    },
    model: {
      value: (_vm.showConvergeModelDialog),
      callback: function($$v) {
        _vm.showConvergeModelDialog = $$v
      },
      expression: "showConvergeModelDialog"
    }
  }, [_c('converge-model-dialog', {
    attrs: {
      "modelId": _vm.modelToConvergeId,
      "modelServices": _vm.modelServices
    },
    on: {
      "dialogClosed": function($event) {
        _vm.showConvergeModelDialog = false
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "main-header"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('img', {
    attrs: {
      "src": "/dist/images/logo-non-vector.png",
      "width": "26",
      "height": "26"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "text-bottom"
    },
    attrs: {
      "src": "/dist/images/logo-non-vector.png",
      "width": "26",
      "height": "26"
    }
  }), _vm._v(" "), _c('b', [_vm._v("ArrowHead")])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu",
    staticStyle: {
      "float": "left",
      "position": "relative",
      "left": "35%"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.currentModelId) ? _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.currentModelId))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('p', [_vm._v("\n                            " + _vm._s(_vm.currentModelId) + "\n")])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "tag": "a",
      "to": {
        name: 'model-editor',
        params: {
          modelId: _vm.currentModelId
        }
      }
    }
  }, [_vm._v("Edit")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": function($event) {
        return _vm.convergeModel()
      }
    }
  }, [_vm._v("Converge")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "tag": "a",
      "to": {
        name: 'model-reports',
        params: {
          modelId: _vm.currentModelId
        }
      }
    }
  }, [_vm._v("Reports")])], 1)])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(" " + _vm._s(_vm.activeUserName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('p', [_vm._v("\n                            " + _vm._s(_vm.activeUserName) + "\n                        ")])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.resetPassword
    }
  }, [_vm._v("Reset Password")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Sign out")])])])])]), _vm._v(" "), (_vm.checkCapability('AI Assistant/access')) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleAiAssistant($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comments"
  })])]) : _vm._e(), _vm._v(" "), _vm._m(1)])])])], 1), _vm._v(" "), _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "pull-left info",
    staticStyle: {
      "position": "unset !important"
    }
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.activeUserName) + " ")]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("NAVIGATION")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/models"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', [_vm._v("Models")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/convergence/monitor"
    }
  }, [_c('i', {
    staticClass: "fa fa-microchip"
  }), _vm._v(" "), _c('span', [_vm._v("Convergence")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "disabled": !_vm.checkCapability('Dashboards/list')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/dashboard-list"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboards")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-question"
  }), _vm._v(" "), _c('span', [_vm._v("Help")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/accounts"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v(" User Accounts")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/db"
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v(" "), _c('span', [_vm._v(" Database Admin")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/convergence"
    }
  }, [_c('i', {
    staticClass: "fa fa-microchip"
  }), _vm._v(" "), _c('span', [_vm._v(" Convergence Admin")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/notifications"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" "), _c('span', [_vm._v(" Notifications")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/modellocks"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" "), _c('span', [_vm._v(" Model Locks")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin/siteinfo"
    }
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" "), _c('span', [_vm._v(" Site Information")])])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content container-fluid",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "main-container"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "main-footer navbar-fixed-bottom"
  }, [(_vm.siteInfo) ? _c('div', {
    staticClass: "pull-right hidden-xs"
  }, [_c('strong', [_vm._v("Site compiled: ")]), _vm._v(" " + _vm._s(_vm.getSetInfoDateString()) + "\n            "), _c('strong', [_vm._v(" Database: ")]), _vm._v("  " + _vm._s(_vm.siteInfo.databaseInfo) + " " + _vm._s(_vm.siteInfo.dbPrefix) + "\n            "), _c('strong', [_vm._v("Converger: ")]), _vm._v(" " + _vm._s(_vm.siteInfo.convergerInfo) + "\n\n        ")]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("\n            Copyright © 2015-\n            "), _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v(" ArrowHead Economics LLC")])], 1), _vm._v(" All rights reserved.\n    ")]), _vm._v(" "), _c('recent-items-list'), _vm._v(" "), (_vm.checkCapability('AI Assistant/access')) ? _c('aside', {
    staticClass: "ai-assistant-sidebar",
    class: {
      'ai-assistant-open': _vm.showAiAssistant
    }
  }, [_c('div', {
    staticClass: "ai-assistant-header"
  }, [_c('h4', [_vm._v("AI Assistant")]), _vm._v(" "), _c('button', {
    staticClass: "close-btn",
    on: {
      "click": _vm.toggleAiAssistant
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('section', {
    staticClass: "ai-assistant-content"
  }, [_c('ai-assistant', {
    attrs: {
      "modelId": _vm.currentModelId
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "control-sidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/dist/images/user-160x160-grey.png",
      "alt": "User Image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle text-success"
  }), _vm._v(" Online")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-link"
  }), _vm._v(" "), _c('span', [_vm._v("Tools")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f957ee94", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f957ee94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/app/app.vue.html
// module id = 1138
// module chunks = 0